import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { HiOutlineArrowDownTray } from 'react-icons/hi2';
import { PrimaryButton } from '../../components/button';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { Constants } from '../../lib/const/constants';
import getCurrencySymbol from '../../lib/currenyUtils';
import { initiateWalletTransaction } from '../../utils/CommonFunctions';
import { encryptPayload } from '../../utils/encryption';
import { amountFormat } from '../../utils/formatAmount';
import { ticketCreate, getAllTicket } from '../../api/ticketApi';
import { splitTransactionId } from '../../utils/ticketUtils';
import {
  ALLOWED_ATTACHMENT_ACCEPT,
  isAllowedAttachmentType,
  ATTACHMENT_TYPE_ERROR,
  DUPLICATE_FILE_ERROR,
  FILE_SIZE_ERROR,
  MAX_FILE_SIZE_MB,
  isFileTooLarge,
  removeDuplicateFiles,
} from '../../utils/fileValidation';
import DOMPurify from 'dompurify';
import PropTypes from 'prop-types';
import { ArrowLeft, ArrowRight } from 'lucide-react';

const REPORT_ISSUES = [
  "I don't recognise this transfer",
  'I did not make this transfer',
  'Incorrect amount',
  'Transfer sent to wrong account',
  'Transfer was duplicated',
  'Transfer has not been received',
  'Other',
];
const REPORT_DESCRIPTION_MAX = 500;

const convertToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

function TransactionListDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const { txn, formatteddate, formattedtime, transactionDetails } =
    location.state || {};
  const receive_currency = transactionDetails?.receive_currency;

  console.log('transactionDetails', transactionDetails);
  console.log('transactionDetails', transactionDetails.beneficiaryName);

  const [notes, setNotes] = useState('');
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [downloadId, setDownloadId] = useState(0);
  const [showDocuments, setShowDocuments] = useState(false);
  const [documents, setDocuments] = useState(
    transactionDetails?.uploadedDocuments || [],
  );

  const [buttonLoading, setButtonLoading] = useState(false);
  const [showId, setShowId] = useState(false);
  const [beneficiaries, setBeneficiaries] = useState([]);

  const [showNotes, setShowNotes] = useState(false);
  const [showReport, setShowReport] = useState(false);
  const [dragActive, setDragActive] = useState(false);
  const [ticketLoading, setTicketLoading] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    category: '',
    attachments: [],
  });

  const reportAttachmentsRef = useRef([]);
  const setReportAttachments = (attachments) => {
    reportAttachmentsRef.current = attachments;
    setFormData((prev) => ({ ...prev, attachments }));
  };
  const [transactionTickets, setTransactionTickets] = useState([]);

  useEffect(() => {
    const txnId = transactionDetails?.debittransactionId;
    if (!txnId) return undefined;

    const fetchTransactionTickets = async () => {
      try {
        const workspace_id = sessionStorage.getItem('login_workspaces_id');
        const data = await getAllTicket(workspace_id);
        setTransactionTickets(
          (data?.results || []).filter(
            (t) =>
              splitTransactionId(t.description).transactionId === String(txnId),
          ),
        );
      } catch (err) {
        console.log('error', err);
      }
    };

    fetchTransactionTickets();
    window.addEventListener('tickets-refresh', fetchTransactionTickets);
    return () => {
      window.removeEventListener('tickets-refresh', fetchTransactionTickets);
    };
  }, [transactionDetails?.debittransactionId]);

  console.log('transactionparamsdata', location.state);

  console.log(downloadId);
  const getCountryFlagUrl = (currencycode) => {
    switch (currencycode) {
      case 'EUR':
        return `${Constants.FXMASTER_BASE_URL}flags/eu.png`;
      case 'RON':
        return `${Constants.FXMASTER_BASE_URL}flags/ro.png`;
      case 'DKK':
        return `${Constants.FXMASTER_BASE_URL}flags/dk.png`;
      case 'NOK':
        return `${Constants.FXMASTER_BASE_URL}flags/no.png`;
      case 'SEK':
        return `${Constants.FXMASTER_BASE_URL}flags/se.png`;
      case 'MYR':
        return `${Constants.FXMASTER_BASE_URL}flags/my.png`;
      case 'GBP':
        return `${Constants.FXMASTER_BASE_URL}flags/UK.png`;
      default:
        return `${Constants.FXMASTER_BASE_URL}flags/${currencycode?.slice(0, 2)}.png`;
    }
  };
  const CurrencyFlag = ({ currencycode }) => {
    if (!currencycode) return null;
    const flagurl = getCountryFlagUrl(currencycode);
    return (
      <img
        src={flagurl}
        alt={currencycode}
        style={{
          width: 16,
          height: 16,
          borderRadius: '50%',
          objectFit: 'cover',
          marginLeft: 8,
          verticalAlign: 'middle',
          alignSelf: 'center',
          display: 'block',
        }}
      />
    );
  };

  CurrencyFlag.propTypes = {
    currencycode: PropTypes.string,
  };

  if (!txn) {
    navigate(-1);
    return null;
  }

  const {
    id,
    beneName,
    date,
    transactionType,
    debittransactionId,
    createdat,
    updatedat,
    sellAmount,
    send_MoneySendAmount,
    currency,
    status,
    reason,
    reference,
    cardFees,
    beneficiaryName,
    beneBankNumber,
    code,
    senderName,
    beneBankType,
    beneficiarybankType,
    creditAmount,
    transactionIds,
    rawMeta = {},
  } = transactionDetails || {};
  const {
    transfer_fee = 0,
    service_fee = 0,
    sender_currency = currency,
  } = rawMeta;
  const transferReason = String(
    rawMeta.reason || rawMeta.conversion_meta?.reason || reason || '',
  )
    .trim()
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
  const paymentReference = String(
    rawMeta.reference || reference || '',
  )
    .trim()
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
  console.log(createdat);
  console.log(updatedat);
  console.log(date);
  console.log(beneficiaryName);
  console.log("Account Number",beneBankNumber);
  console.log("code",code);
  console.log("Receive currecny",receive_currency)
  console.log(senderName);

  console.log('Transfer Fee', rawMeta);

  const createDate = new Date(createdat.replace(' ', 'T'));
  const create_date =
    [
      String(createDate.getDate()).padStart(2, '0'),
      String(createDate.getMonth() + 1).padStart(2, '0'),
      createDate.getFullYear(),
    ].join('-') +
    ' ' +
    [
      String(createDate.getHours()).padStart(2, '0'),
      String(createDate.getMinutes()).padStart(2, '0'),
      String(createDate.getSeconds()).padStart(2, '0'),
    ].join(':');

  const updateDate = new Date(updatedat.replace(' ', 'T'));
  const update_date =
    [
      String(updateDate.getDate()).padStart(2, '0'),
      String(updateDate.getMonth() + 1).padStart(2, '0'),
      updateDate.getFullYear(),
    ].join('-') +
    ' ' +
    [
      String(updateDate.getHours()).padStart(2, '0'),
      String(updateDate.getMinutes()).padStart(2, '0'),
      String(updateDate.getSeconds()).padStart(2, '0'),
    ].join(':');

  const formatAmount = (value) => {
    if (!value) return value;
    const symbol = String(value).match(/^[^\d]+/)?.[0] ?? '';
    const num = parseFloat(String(value).replace(/[^\d.]/g, ''));
    if (isNaN(num)) return value;
    return `${symbol}${num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  const total_amount = (
    (parseFloat(String(sellAmount).replace(/[^\d.]/g, '')) || 0) +
    (parseFloat(transfer_fee) || 0) +
    (parseFloat(service_fee) || 0)
  ).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const formatGBPAmount = (value) => {
    if (value === null || value === undefined || value === '') return '£ 0.00';
    const num = parseFloat(String(value).replace(/[^\d.]/g, ''));
    if (isNaN(num)) return '£ 0.00';
    return `£ ${num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  const displayAmount =
    beneBankType === 'business' || beneficiarybankType === 'business'
      ? formatGBPAmount(creditAmount)
      : transactionType === 'debit'
        ? formatAmount(send_MoneySendAmount)
        : '-';

  const handleSingleFileChange = (e) => {
    if (e.target.files.length > 0) {
      const selectedFile = e.target.files[0];
      if (isFileTooLarge(selectedFile)) {
        toast.error(FILE_SIZE_ERROR);
        e.target.value = '';
      } else if (isAllowedAttachmentType(selectedFile)) {
        setFile(selectedFile);
      } else {
        toast.error(ATTACHMENT_TYPE_ERROR);
        e.target.value = '';
      }
    }
  };

  const handleCancel = () => {
    setFile(null);
    setNotes('');
    const fileInput = document.getElementById('file-upload');
    if (fileInput) fileInput.value = '';
  };

  const handleSubmit = () => {
    if (!file) {
      toast.error('Please upload file.');
      return;
    }
    setUploading(true);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = async () => {
      const token = sessionStorage.getItem('login_token');
      const extension = file.name.split('.');
      try {
        const encryptedPayload = await encryptPayload({
          document: reader.result,
          transaction_id: id,
          notes: notes || 'NA',
          extension: extension[extension.length - 1],
          platform: 'web',
          extraParamValidation: 'trustedfromweb',
        });
        await axios.post(
          Constants.BASE_URL + 'API-FX-195-UPLOAD-USER-TRANSACTION-DOCUMENTS',
          encryptedPayload,
          {
            headers: {
              Authorization: 'Bearer ' + JSON.parse(token),
              fx_key: Constants.SUBSCRIPTION_KEY,
            },
          },
        );
        toast.success('Uploaded Successfully.');
        setDocuments((prev) => [
          ...prev,
          { notes: notes || 'NA', document: file.name },
        ]);
        setUploading(false);
        setFile(null);
        setNotes('');
      } catch {
        toast.error('Something went wrong. Please try again later.');
        setUploading(false);
      }
    };
  };

  const downloadReceipt = async () => {
    if (downloadId) return;
    setDownloadId(id);
    const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
    try {
      const encryptedPayload = await encryptPayload({
        id,
        workspace_id: login_workspaces_id,
        platform: 'web',
        extraParamValidation: 'trustedfromweb',
      });
      const resp = await axios.post(
        Constants.BASE_URL + 'API-FX-208-DOWNLOAD-TRANSACTION-RECEIPT',
        encryptedPayload,
        {
          headers: {
            'Content-Type': 'application/json',
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        },
      );
      const docData = resp.data.document;
      const parsed =
        typeof docData === 'string' ? JSON.parse(docData) : docData;
      if (!parsed?.url) {
        toast.error(
          resp?.data?.message && resp.data.message !== 'Success'
            ? resp.data.message
            : 'Receipt is not available for this transaction.',
        );
        return;
      }
      window.open(parsed.url, '_blank');
    } catch (err) {
      console.error('Download receipt error:', err);
      toast.error(
        err?.response?.data?.message ||
          'Unable to download the receipt. Please try again later.',
      );
    } finally {
      setDownloadId(0);
    }
  };

  const handleRepeatTransaction = async () => {
    try {
      const token = sessionStorage.getItem('login_token');
      const workspaceId = sessionStorage.getItem('login_workspaces_id');
      const staff_login_id = sessionStorage.getItem('staff_login_id');

      const parsedMeta = txn?.meta ? JSON.parse(txn.meta) : {};

      const lastTransaction = {
        ...txn,
        meta_data: parsedMeta,
        currency: currency || 'GBP',
      };

      if (!lastTransaction) {
        toast.error('Transaction data not available for repeat.');
        return;
      }

      setButtonLoading(true);

      const conversionMeta = parsedMeta?.conversion_meta;

      const send_amount =
        conversionMeta?.conversion_client_sell_amount ||
        lastTransaction?.amount;

      const sellCurrency = transactionDetails?.sell_currency_country_id || 231;
      const buyCurrency = transactionDetails?.buy_currency_country_id || 105;
      const encryptedPayload = await encryptPayload({
        sell_currency_country_id: sellCurrency,
        buy_currency_country_id: buyCurrency,
        amount: parseFloat(parseFloat(send_amount).toFixed(2)),
        workspace_id: workspaceId,
        type: 'sell',
        staff_login_id: staff_login_id,
        platform: 'web',
        extraParamValidation: 'trustedfromweb',
      });
      const convResp = await axios.post(
        Constants.BASE_URL + 'API-FX-163-CONVERTRATES',
        encryptedPayload,
        {
          headers: {
            fx_key: Constants.SUBSCRIPTION_KEY,
            Authorization: 'Bearer ' + JSON.parse(token),
          },
        },
      );

      console.log('convResp', convResp);
      const freshContactId = convResp.data.contact_id;

      if (!freshContactId) {
        toast.error('Could not get contact ID for repeat transaction.');
        setButtonLoading(false);
        return;
      }

      localStorage.setItem('repeat_contactId', freshContactId);

      let activeBeneficiaries = beneficiaries;

      if (!activeBeneficiaries || activeBeneficiaries.length === 0) {
        const encryptedPayload = await encryptPayload({
          workspace_id: workspaceId,
          platform: 'web',
          extraParamValidation: 'trustedfromweb',
        });
        const clearResp = await axios.post(
          Constants.BASE_URL + 'API-FX-191-CLEAR-BANK-LIST-BENEFICIARY',
          encryptedPayload,
          {
            headers: {
              fx_key: Constants.SUBSCRIPTION_KEY,
              Authorization: 'Bearer ' + JSON.parse(token),
            },
          },
        );

        const clearBenes = clearResp.data.data.map((element) => ({
          id: element.id,
          display_name: element.beneficiaryName,
          bank_account_number: element.banks[0].accountNumber,
          country_flag: Constants.FXMASTER_BASE_URL + 'flags/UK.png',
          code: element.banks[0].sortCode,
          bene_type: element.type,
          bank_type: 'clear_bank',
        }));

        const ccResp = await axios.get(
          `${Constants.BASE_URL}API-FX-126-ListBeneficiary`,
          {
            params: {
              workspace_id: workspaceId,
              reference_type: 'money_transfer',
            },
            headers: {
              fx_key: Constants.SUBSCRIPTION_KEY,
              Authorization: `Bearer ${JSON.parse(token)}`,
            },
          },
        );

        const ccBenes = ccResp.data.data.map((el) => ({
          id: el.id,
          display_name: el.display_name,
          bank_account_number: el.meta.bank_account_number || el.meta.iban,
          country_flag: el.country_flag,
          code:
            el.meta.bic_number ??
            el.meta.aba_number ??
            el.meta.sort_code ??
            el.meta.branch_code ??
            el.meta.bsb_number ??
            el.meta.bank_code ??
            el.meta.ifsc_code ??
            el.meta.routing_code_value_1,
          bene_type: el.type,
          bank_type: 'currency_cloud',
        }));

        activeBeneficiaries = [...clearBenes, ...ccBenes];
        setBeneficiaries(activeBeneficiaries);
      }

      await initiateWalletTransaction({
        lastTransaction,
        beneficiaries: activeBeneficiaries,
        currency: lastTransaction?.currency || 'GBP',
        currencyid: 231,
        navigate,
        ref: '',
        setButtonLoading,
        setcurrencyCloudBalance: () => { },
        setclearBankBalance: () => { },
        setclearBankConfiguration: () => { },
        toast,
      });
    } catch (err) {
      console.error('Repeat error:', err);
      toast.error(
        err?.response?.data?.message || 'Failed to prepare repeat transaction.',
      );
      setButtonLoading(false);
    }
  };

  const addReportFiles = async (fileList) => {
    const selectedFiles = Array.from(fileList || []);
    if (selectedFiles.length === 0) return;

    const typeValidFiles = selectedFiles.filter((f) =>
      isAllowedAttachmentType(f),
    );
    if (typeValidFiles.length < selectedFiles.length) {
      toast.error(ATTACHMENT_TYPE_ERROR);
    }
    const filesArray = typeValidFiles.filter((f) => !isFileTooLarge(f));
    if (filesArray.length < typeValidFiles.length) {
      toast.error(FILE_SIZE_ERROR);
    }
    if (filesArray.length === 0) return;

    try {
      const base64Files = await Promise.all(
        filesArray.map(async (f) => ({
          name: f.name,
          data: await convertToBase64(f),
        })),
      );
      const currentAttachments = reportAttachmentsRef.current;
      const newFiles = removeDuplicateFiles(base64Files, currentAttachments);
      if (newFiles.length < base64Files.length) {
        toast.error(DUPLICATE_FILE_ERROR);
      }
      if (newFiles.length === 0) return;

      setReportAttachments([...currentAttachments, ...newFiles]);
    } catch {
      toast.error('Unable to read the selected file. Please try again.');
    }
  };

  const handleReportFileChange = async (e) => {
    await addReportFiles(e.target.files);
    e.target.value = '';
  };

  const handleReportDrop = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    await addReportFiles(e.dataTransfer.files);
  };

  const handleReportDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(e.type === 'dragenter' || e.type === 'dragover');
  };

  const removeReportAttachment = (index) => {
    setReportAttachments(
      reportAttachmentsRef.current.filter((_, i) => i !== index),
    );
  };

  const handleReviewSubmit = async () => {
    if (!formData.title) {
      toast.error('Please select the issue with this transaction.');
      return;
    }
    if (!formData.description.trim()) {
      toast.error('Please provide additional information about this transaction.');
      return;
    }

    setTicketLoading(true);
    try {
      const form = new FormData();
      form.append('title', formData.title);
      form.append(
        'description',
        `${formData.description.trim()}\n\nTransaction ID: ${debittransactionId}`,
      );
      form.append('category', formData.category || 'transaction');
      form.append('workspace', sessionStorage.getItem('login_workspaces_id'));
      formData.attachments.forEach((f) => {
        form.append('attachments[]', f.data);
      });

      const res = await ticketCreate(form);
      if (res.status === 200 && res.data.message === 'Success') {
        toast.success('Ticket created successfully.');
        reportAttachmentsRef.current = [];
        setFormData({
          title: '',
          description: '',
          category: '',
          attachments: [],
        });
      } else {
        throw new Error(res?.data?.message || 'Ticket creation failed.');
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.message ||
          err?.message ||
          'Something went wrong. Please try again later.',
      );
    } finally {
      setTicketLoading(false);
    }
  };

  const getStatusStyle = (s) => {
    const st = (s || '').toLowerCase();
    if (st === 'completed' || st === 'settled')
      return { bg: '#e8f5e9', color: '#2e7d32' };
    if (st === 'pending' || st === 'review')
      return { bg: '#fff3e0', color: '#e65100' };
    if (st === 'processing') return { bg: '#e3f2fd', color: '#1565c0' };
    if (st === 'waiting for funds') return { bg: '#fce4ec', color: '#b71c1c' };
    return { bg: '#f3f4f6', color: '#374151' };
  };

  const capitalizeFirst = (str) => {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const statusStyle = getStatusStyle(status);
  const account_type = sessionStorage.getItem('account_type');

  const formatStepTime = (value) => {
    if (!value) return '';
    const d = new Date(String(value).replace(' ', 'T'));
    if (isNaN(d.getTime())) return '';
    return (
      [
        String(d.getDate()).padStart(2, '0'),
        String(d.getMonth() + 1).padStart(2, '0'),
        d.getFullYear(),
      ].join('-') +
      ' ' +
      [
        String(d.getHours()).padStart(2, '0'),
        String(d.getMinutes()).padStart(2, '0'),
        String(d.getSeconds()).padStart(2, '0'),
      ].join(':')
    );
  };

  const showStepper = transactionType?.toLowerCase() === 'debit';
  const SUCCESS_STATUSES = ['settled', 'submitted', 'completed', 'accepted'];
  const FAILED_STATUSES = [
    'cancelled',
    'declined',
    'failed',
    'deleted',
    'rejected',
    'returned',
  ];
  const stepStatus = String(status || '').trim().toLowerCase();
  const isSuccess = SUCCESS_STATUSES.includes(stepStatus);
  const isFailed = FAILED_STATUSES.includes(stepStatus);
  const isFunded =
    String(rawMeta.partner_status || '').trim().toLowerCase() === 'funded';

  const fundsState =
    isSuccess || isFunded ? 'done' : isFailed ? 'failed' : 'current';
  const processingState = isSuccess
    ? 'done'
    : isFunded
      ? isFailed
        ? 'done'
        : 'current'
      : isFailed
        ? 'failed'
        : 'empty';
  const finalState = isSuccess ? 'done' : isFailed ? 'failed' : 'empty';

  const paymentSteps = [
    {
      title: 'Submitted',
      desc: 'Your transfer has been submitted.',
      time: create_date,
      state: 'done',
    },
    {
      title: 'Funds received',
      desc:
        fundsState === 'done'
          ? 'We have received your funds.'
          : fundsState === 'failed'
            ? 'Funds not received.'
            : 'Awaiting your funds.',
      time: isFunded ? formatStepTime(rawMeta.partner_payment_status_time) : '',
      state: fundsState,
    },
    {
      title: 'Processing',
      desc:
        processingState === 'done'
          ? 'Your payment has been processed.'
          : processingState === 'failed'
            ? 'Not processed.'
            : 'Your payment is being processed.',
      time: '',
      state: processingState,
    },
    {
      title: isFailed ? 'Failed' : 'Delivered',
      desc: isSuccess
        ? 'Your payment has been delivered.'
        : isFailed
          ? 'Your payment has failed.'
          : 'Awaiting confirmation.',
      time: '',
      state: finalState,
    },
  ];

  return (
    <div className="txn-page">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');
        * { box-sizing: border-box; }

        .txn-page {
          min-height: 100vh;
          padding: 32px 16px 48px;
          font-family: 'DM Sans', sans-serif;
          background: linear-gradient(to bottom, #f8fafc, #eff6ff4d, #eef2ff66);
        }
        .content-area { width: 100%; max-width: 640px; margin: 0 auto; }

        .main-card {
          background: #fff; border-radius: 16px;
          box-shadow: 0 2px 12px rgba(11,33,78,0.08); overflow: hidden;
        }

        .hero-card {
          padding: 18px 20px; display: flex; align-items: center;
          justify-content: space-between; flex-wrap: wrap; gap: 12px;
          border-bottom: 1px solid #eef0f3;
        }
        .hero-left { display: flex; align-items: center; gap: 12px; }
        .hero-avatar {
          width: 40px; height: 40px; border-radius: 50%;
          background: #6b7280; color: #fff;
          display: flex; align-items: center; justify-content: center;
          font-weight: 700; font-size: 16px; flex-shrink: 0;
        }
        .hero-name { font-weight: 600; font-size: 15px; color: #1E2A3B; }
        .hero-amount { font-weight: 600; font-size: 15px; color: #1E2A3B; margin-left: 8px; }
        .hero-date { font-size: 12px; color: #9ca3af; margin-top: 2px; }
        .hero-right { display: flex; align-items: center; gap: 10px; }

        .icon-btn {
          width: 36px; height: 36px; border-radius: 8px;
          border: 1.5px solid #e5e7eb; background: #fff;
          display: flex; align-items: center; justify-content: center;
          cursor: pointer; color: #374151; transition: all 0.15s;
        }
        .icon-btn:hover { background: #f3f4f6; }

        .repeat-btn {
          display: flex; align-items: center; gap: 8px;
          height: 38px; padding: 0 18px; border-radius: 8px;
          background: #E8640A; color: #fff; border: none;
          font-weight: 600; font-size: 14px; cursor: pointer;
          font-family: 'DM Sans', sans-serif; transition: all 0.15s;
          white-space: nowrap; min-width: 130px; justify-content: center;
        }
        .repeat-btn:hover:not(:disabled) { background: #d0560a; }
        .repeat-btn:disabled { opacity: 0.65; cursor: not-allowed; }

        .detail-card { border-bottom: 1px solid #eef0f3; padding-bottom: 6px; }

        .txn-stepper {
          display: flex; padding: 20px 12px 18px; margin-bottom: 16px;
          background: #fff; border-radius: 16px;
          box-shadow: 0 2px 12px rgba(11,33,78,0.08);
        }
        .txn-step {
          flex: 1; position: relative; display: flex; flex-direction: column;
          align-items: center; text-align: center; padding: 0 6px;
        }
        .txn-step:not(:last-child)::after {
          content: ''; position: absolute; top: 13px;
          left: calc(50% + 18px); right: calc(-50% + 18px);
          border-top: 2px solid #1F4FA0;
        }
        .txn-step.next-empty::after { border-top: 2px dashed #C4C8CE; }
        .txn-step.next-failed::after { border-top-color: #D92D20; }
        .step-dot {
          width: 28px; height: 28px; border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          flex-shrink: 0; box-sizing: border-box;
        }
        .step-dot svg { width: 14px; height: 14px; }
        .step-dot.done { background: #1F4FA0; color: #fff; }
        .step-dot.failed { background: #D92D20; color: #fff; }
        .step-dot.current { background: #fff; border: 2px solid #F26B1D; }
        .step-dot.current span {
          width: 14px; height: 14px; border-radius: 50%; background: #F26B1D;
        }
        .step-dot.empty { background: #fff; border: 2px solid #C4C8CE; }
        .step-title { font-size: 13px; font-weight: 700; color: #1E2A3B; margin-top: 10px; }
        .step-title.failed { color: #D92D20; }
        .step-title.empty { color: #1E2A3B; }
        .step-desc { font-size: 12px; font-weight: 500; color: #6b7280; margin-top: 3px; line-height: 1.4; }
        .step-time { font-size: 12px; color: #9ca3af; margin-top: 3px; }


        .section-title {
          font-size: 13px; font-weight: 700; color: #1E2A3B;
          padding: 16px 20px 8px;
        }
        .detail-table { width: 100%; border-collapse: collapse; }
        .detail-table tr td { padding: 8px 20px; font-size: 13px; }
        .detail-table tr td:first-child { color: #6b7280; font-weight: 500; width: 42%; font-size: 13px; }
        .detail-table tr td:last-child { color: #1E2A3B; font-weight: 600; font-size: 13px; }

        .collapse-header {
          width: 100%; background: none; border: none; cursor: pointer;
          display: flex; align-items: center; justify-content: space-between;
          padding: 16px 20px; font-family: 'DM Sans', sans-serif; text-align: left;
        }
        .collapse-title { font-size: 13px; font-weight: 700; color: #1E2A3B; }
        .collapse-chevron { width: 16px; height: 16px; color: #6b7280; flex-shrink: 0; }

        .notes-card { border-bottom: 1px solid #eef0f3; }
        .notes-body { padding: 0 20px 20px; }
        .notes-textarea {
          width: 100%; border: 1.5px solid #e5e7eb; border-radius: 12px;
          padding: 12px 14px; font-size: 13px; font-family: 'DM Sans', sans-serif;
          resize: vertical; outline: none; color: #374151; background: #fff;
          transition: border 0.15s; min-height: 80px;
        }
        .notes-textarea:focus { border-color: #1E2A3B; }
        .notes-textarea::placeholder { color: #9ca3af; }

        .notes-actions-row {
          display: flex; align-items: center; justify-content: space-between; margin-top: 14px;
        }
        .upload-label {
          display: flex; align-items: center; gap: 8px;
          color: #1d4ed8; font-weight: 600; font-size: 13px; cursor: pointer;
        }
        .upload-label:hover { opacity: 0.8; }

        .view-toggle-btn {
          display: flex; align-items: center; gap: 5px;
          background: none; border: none; color: #374151;
          font-size: 13px; font-weight: 600; cursor: pointer; font-family: 'DM Sans', sans-serif;
        }
        .view-toggle-btn:hover { color: #111827; }

        .file-selected-pill {
          display: inline-flex; align-items: center; gap: 6px;
          background: #f0fdf4; color: #16a34a; font-size: 12px; font-weight: 600;
          padding: 4px 10px; border-radius: 20px; margin-top: 8px;
        }

        .doc-table { width: 100%; border-collapse: collapse; margin-top: 16px; }
        .doc-table th {
          text-align: left; font-size: 13px; font-weight: 600; color: #1E2A3B;
          padding: 8px 0 10px; border-bottom: 1.5px solid #e5e7eb;
        }
        .doc-table td {
          padding: 12px 0; font-size: 13px; border-bottom: 1px solid #f0f2f5; color: #6b7280;
        }
        .doc-table tr:last-child td { border-bottom: none; }
        .doc-table td:first-child { width: 48px; color: #374151; font-weight: 500; }
        .view-doc-btn {
          display: flex; align-items: center; gap: 6px;
          color: #374151; font-weight: 600; font-size: 13px; text-decoration: none;
        }
        .view-doc-btn:hover { color: #1E2A3B; }

        .action-row {
          display: flex; gap: 10px; margin-top: 16px; justify-content: flex-end;
        }
        .cancel-btn {
          border: 1.5px solid #1E2A3B; color: #1E2A3B; background: none;
          border-radius: 8px; padding: 8px 24px; font-weight: 600;
          cursor: pointer; font-family: 'DM Sans', sans-serif; font-size: 13px;
        }
        .save-btn {
          background: #1E2A3B; color: #fff; border: none;
          border-radius: 8px; padding: 8px 24px; font-weight: 600;
          cursor: pointer; font-family: 'DM Sans', sans-serif; font-size: 13px;
        }

        .report-header-left { display: flex; align-items: center; gap: 12px; }
        .report-icon {
          width: 32px; height: 32px; border-radius: 50%; background: #eef2ff;
          color: #394784; display: flex; align-items: center; justify-content: center;
          flex-shrink: 0;
        }
        .report-sub { font-size: 11px; color: #9ca3af; margin-top: 2px; font-weight: 400; }
        .report-body { padding: 4px 20px 20px; }
        .report-question { font-size: 13px; font-weight: 700; color: #1E2A3B; margin-bottom: 12px; }
        .required-star { color: #dc2626; }
        .report-option {
          display: flex; align-items: center; gap: 10px;
          font-size: 13px; color: #4b5563; padding: 6px 0; cursor: pointer;
        }
        .report-option input[type='radio'] {
          width: 15px; height: 15px; margin: 0; accent-color: #E8640A; cursor: pointer;
        }
        .report-label { font-size: 12px; font-weight: 700; color: #1E2A3B; margin: 16px 0 8px; }
        .report-textarea {
          width: 100%; border: 1.5px solid #e5e7eb; border-radius: 10px;
          padding: 10px 12px; font-size: 13px; font-family: 'DM Sans', sans-serif;
          resize: vertical; outline: none; color: #374151; min-height: 72px;
        }
        .report-textarea:focus { border-color: #1E2A3B; }
        .report-textarea::placeholder { color: #9ca3af; }
        .report-counter { text-align: right; font-size: 11px; color: #9ca3af; margin-top: 4px; }
        .dropzone {
          display: flex; align-items: center; gap: 14px;
          border: 1.5px dashed #d1d5db; border-radius: 10px; padding: 14px 16px;
          cursor: pointer; background: #fafafa; transition: all 0.15s;
        }
        .dropzone.active { border-color: #E8640A; background: #fff7ed; }
        .dropzone-title { font-size: 13px; font-weight: 600; color: #1E2A3B; }
        .dropzone-sub { font-size: 11px; color: #9ca3af; margin-top: 2px; }
        .attachment-list { margin-top: 10px; display: flex; flex-direction: column; gap: 6px; }
        .attachment-item {
          display: flex; align-items: center; justify-content: space-between;
          background: #f9fafb; border: 1px solid #eef0f3; border-radius: 8px;
          padding: 6px 10px; font-size: 12px; color: #374151;
        }
        .attachment-remove {
          background: none; border: none; cursor: pointer; color: #9ca3af;
          font-size: 16px; line-height: 1; padding: 0 2px;
        }
        .attachment-remove:hover { color: #dc2626; }

        .submit-btn {
          display: flex; flex-direction: row; align-items: center; justify-content: center;
          gap: 16px; width: 100%; height: 56px; margin-top: 20px;
          border-radius: 12px; padding: 12px 20px; border: none;
          background: #D26521; color: #FFFFFF; cursor: pointer;
          font-size: 15px; font-weight: 600; font-family: 'DM Sans', sans-serif;
          transition: background 0.2s;
        }
        .submit-btn:disabled { background: #D7D7D7; color: #9CA3AF; cursor: not-allowed; }
        .submit-btn.loading:disabled { background: #D26521; color: #FFFFFF; opacity: 0.8; }

        .tickets-section { border-top: 1px solid #eef0f3; }

        .security-banner {
          background: #f5ede6; border: 1px solid #ecdccd; border-radius: 12px;
          padding: 14px 18px; display: flex; align-items: flex-start; gap: 10px; margin-top: 20px;
        }
        .security-banner-title { font-weight: 600; color: #1E2A3B; margin-bottom: 2px; font-size: 13px; }
        .security-banner-sub { color: #6b7280; font-size: 12px; }

        @keyframes spin { to { transform: rotate(360deg); } }
        .spinner {
          width: 15px; height: 15px; border: 2px solid rgba(255,255,255,0.35);
          border-top-color: #fff; border-radius: 50%; animation: spin 0.7s linear infinite;
        }
      `}</style>

      <ToastContainer />

      <div className="content-area">
        <h1 className="text-center text-2xl font-bold text-[#1D2338] mb-6 tracking-tight">
          Transaction View Details
        </h1>

        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-1 text-[#1f2a44] font-bold text-[18px] hover:opacity-70 transition mb-4"
        >
          <ArrowLeft className="w-5 h-5" />
          Back
        </button>

        {showStepper && (
          <div className="txn-stepper">
            {paymentSteps.map((step, idx) => (
              <div
                key={step.title}
                className={`txn-step ${
                  paymentSteps[idx + 1]?.state === 'empty'
                    ? 'next-empty'
                    : paymentSteps[idx + 1]?.state === 'failed'
                      ? 'next-failed'
                      : ''
                }`}
              >
                <div className={`step-dot ${step.state}`}>
                  {step.state === 'done' && (
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round">
                      <path d="M5 12.5l4.5 4.5L19 7.5" />
                    </svg>
                  )}
                  {step.state === 'failed' && (
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={3} strokeLinecap="round">
                      <path d="M7 7l10 10M17 7L7 17" />
                    </svg>
                  )}
                  {step.state === 'current' && <span />}
                </div>
                <div
                  className={`step-title ${
                    step.state === 'failed' || step.state === 'empty'
                      ? step.state
                      : ''
                  }`}
                >
                  {step.title}
                </div>
                <div className="step-desc">{step.desc}</div>
                {step.time && <div className="step-time">{step.time}</div>}
              </div>
            ))}
          </div>
        )}
        <div className="main-card">
        {/* Hero Card */}
        <div className="hero-card">
          <div className="hero-left">
            <div className="hero-avatar">{beneName?.charAt(0)}</div>
            <div>
              <div>
                <span className="hero-name">{beneName}</span>
                <span className="hero-amount">{displayAmount}</span>
              </div>
              <div className="hero-date">
                Sent On : {formatteddate} at {formattedtime}
              </div>
            </div>
          </div>

          <div className="hero-right">
            {transactionIds?.length == 0 && (
              <button
                className="icon-btn"
                onClick={downloadReceipt}
                disabled={!!downloadId}
                title={downloadId ? 'Downloading...' : 'Download Receipt'}
              >
                {downloadId ? (
                  <div
                    className="spinner"
                    style={{
                      borderColor: 'rgba(55,65,81,0.25)',
                      borderTopColor: '#374151',
                    }}
                  />
                ) : (
                  <HiOutlineArrowDownTray size={18} />
                )}
              </button>
            )}

            {account_type?.toLowerCase() !== 'business' &&
              transactionType?.toLowerCase() === 'debit' &&
              status.toLowerCase() === 'settled' && (
                <button
                  className="repeat-btn"
                  disabled={buttonLoading}
                  onClick={handleRepeatTransaction}
                >
                  {buttonLoading ? (
                    <>
                      <div className="spinner" /> Loading...
                    </>
                  ) : (
                    <>{buttonLoading ? 'Processing...' : 'Repeat Again →'}</>
                  )}
                </button>
              )}
          </div>
        </div>

        {/* Transaction Details Card */}
        <div className="detail-card">
          <div className="section-title">Transaction Details</div>
          <table className="detail-table">
            <tbody>
              <tr>
                <td>Transaction ID</td>
                <td>{debittransactionId}</td>
              </tr>
              <tr>
                <td>Type of transaction</td>
                <td
                  style={{
                    textTransform: 'capitalize',
                    fontFamily: 'Inter, sans-serif',
                  }}
                >
                  {transactionType}
                </td>
              </tr>
              {account_type?.toLowerCase() === 'business' ? (
                <tr>
                  <td>Amount</td>
                  <td>
                    <span
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                      }}
                    >
                      {transactionType === 'debit'
                        ? formatAmount(sellAmount)
                        : formatAmount(creditAmount)}
                      <CurrencyFlag
                        currencycode={
                          transactionType === 'debit'
                            ? sender_currency
                            : receive_currency
                        }
                      />
                    </span>
                  </td>
                </tr>
              ) : (
                transactionType === 'debit' && (
                  <tr>
                    <td>
                      {transactionType !== 'debit' ? 'Amount' : 'Sent Amount'}
                    </td>
                    <td>
                      {transactionType === 'debit' ? (
                        <span
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                          }}
                        >
                          {formatAmount(sellAmount) ?? '-'}
                          <CurrencyFlag currencycode={sender_currency} />
                        </span>
                      ) : (
                        '-'
                      )}
                    </td>
                  </tr>
                )
              )}
              {Number(transfer_fee) > 0 && (
                <tr>
                  <td>Transfer Fee</td>
                  <td>
                    <span
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                      }}
                    >
                      {getCurrencySymbol(sender_currency)}
                      {formatAmount(transfer_fee)}
                      <CurrencyFlag currencycode={sender_currency} />
                    </span>
                  </td>
                </tr>
              )}
              {Number(service_fee) > 0 && (
                <tr>
                  <td>Service Fee</td>
                  <td>
                    <span
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                      }}
                    >
                      {getCurrencySymbol(sender_currency)}
                      {formatAmount(service_fee)}
                      <CurrencyFlag currencycode={sender_currency} />
                    </span>
                  </td>
                </tr>
              )}
              {(Number(transfer_fee) > 0 || Number(service_fee) > 0) && (
                <tr>
                  <td>Total Amount</td>
                  <td>
                    <span
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                      }}
                    >
                      {getCurrencySymbol(sender_currency)}
                      {total_amount}
                      <CurrencyFlag currencycode={sender_currency} />
                    </span>
                  </td>
                </tr>
              )}
              {account_type?.toLowerCase() !== 'business' &&
                sellAmount !== 'undefined undefined' && (
                  <tr>
                    <td>Beneficiary gets</td>
                    {/* <td>{formatAmount(send_MoneySendAmount)}</td> */}
                    <td>
                      <span
                        style={{ display: 'inline-flex', alignItems: 'center' }}
                      >
                        {getCurrencySymbol(receive_currency)}
                        {amountFormat(
                          parseFloat(String(send_MoneySendAmount || 0).replace(/[^0-9.]/g, '') || 0).toFixed(2),
                          'INR'
                        )}
                        <CurrencyFlag currencycode={receive_currency} />
                      </span>
                    </td>
                  </tr>
                )}

              <tr>
                <td>Created Date</td>
                <td>{create_date}</td>
              </tr>
              <tr>
                <td>Updated Date</td>
                <td>{update_date}</td>
              </tr>
              <tr>
                <td>Status</td>
                <td>
                  <span
                    style={{
                      background: statusStyle.bg,
                      color: statusStyle.color,
                      fontFamily: 'Inter, sans-serif',
                      padding: '3px 10px',
                      borderRadius: 20,
                      fontSize: 12,
                      fontWeight: 600,
                    }}
                  >
                    {capitalizeFirst(status)}
                  </span>
                </td>
              </tr>
              {(transferReason || transactionIds?.length > 0) && (
              <tr>
                <td>Transfer Reason</td>
                <td>
                  {transferReason}
                  {transactionIds?.length > 0 && (
                    <>
                      <PrimaryButton
                        label={
                          !showId
                            ? "View Transactions Id's"
                            : "Hide Transactions Id's"
                        }
                        style={{ width: 160, marginTop: 8 }}
                        onClick={() => setShowId(!showId)}
                      />
                      {showId &&
                        transactionIds.map((resp, index) => {
                          return (
                            <div key={index} className="my-2">
                              {index + 1}) {resp}
                            </div>
                          );
                        })}
                    </>
                  )}
                </td>
              </tr>
              )}
              {paymentReference && (
                <tr>
                  <td>Payment Reference</td>
                  <td>{paymentReference}</td>
                </tr>
              )}
              {cardFees && cardFees !== '' && (
                <tr>
                  <td>Fees</td>
                  <td>GBP {cardFees}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Beneficiary / Sender Card */}
        {transactionDetails?.beneficiaryName !== 'Conversion Credit' &&
          transactionDetails?.beneficiaryName !== 'Conversion Debit' && (
            <div className="detail-card">
              <div className="section-title">
                {transactionType === 'debit'
                  ? 'Beneficiary Details'
                  : 'Sender Details'}
              </div>
              <table className="detail-table">
                <tbody>
                  {transactionType === 'debit' ? (
                    <>
                      <tr>
                        <td>Account Name</td>
                        <td>{beneficiaryName}</td>
                      </tr>
                      <tr>
                        <td>
                          {receive_currency === 'INR' && code === '-'
                            ? 'UPI ID'
                            : 'Account Number'}
                        </td>
                        <td>{beneBankNumber}</td>
                      </tr>
                      {code !== '-' && (
                        <tr>
                          <td>{receive_currency === 'GBP' && /^\d+$/.test(code || '') ? 'Sort Code' : 'Code'}</td>
                          <td>
                            {receive_currency?.toUpperCase() === 'GBP' && /^\d+$/.test(code || '')
                              ? code
                                ?.replace(/\D/g, '')
                                .replace(/(\d{2})(\d{2})(\d{2})/, '$1-$2-$3')
                              : code}
                          </td>
                        </tr>
                      )}
                    </>
                  ) : (
                    <tr>
                      <td>Sender Name</td>
                      <td>{senderName}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}

        {/* Notes & Attachments */}

        {transactionDetails?.beneficiaryName !== 'Conversion Credit' &&
          transactionDetails?.beneficiaryName !== 'Conversion Debit' && (
            <div className="notes-card">
              <button
                type="button"
                className="collapse-header"
                onClick={() => setShowNotes((prev) => !prev)}
              >
                <span className="collapse-title">Notes & Attachments</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={2.5}
                  stroke="currentColor"
                  className="collapse-chevron"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d={
                      showNotes
                        ? 'M4.5 15.75l7.5-7.5 7.5 7.5'
                        : 'M19.5 8.25l-7.5 7.5-7.5-7.5'
                    }
                  />
                </svg>
              </button>

              {showNotes && (
              <div className="notes-body">
              <textarea
                className="notes-textarea"
                rows="3"
                placeholder="Add notes..."
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
              />

              {file && (
                <div className="file-selected-pill">
                  <span>✓</span> {file.name}
                </div>
              )}

              <div className="notes-actions-row">
                <label htmlFor="file-upload" className="upload-label">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={2}
                    stroke="currentColor"
                    style={{
                      width: 18,
                      height: 18,
                      fontFamily: 'Inter, sans-serif',
                    }}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5"
                    />
                  </svg>
                  Upload Documents
                </label>
                <input
                  id="file-upload"
                  type="file"
                  accept={ALLOWED_ATTACHMENT_ACCEPT}
                  onChange={handleSingleFileChange}
                  style={{ display: 'none' }}
                />

                {documents.length > 0 && (
                  <button
                    className="view-toggle-btn"
                    onClick={() => setShowDocuments((prev) => !prev)}
                  >
                    View
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={2.5}
                      stroke="currentColor"
                      style={{ width: 14, height: 14 }}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d={
                          showDocuments
                            ? 'M4.5 15.75l7.5-7.5 7.5 7.5'
                            : 'M19.5 8.25l-7.5 7.5-7.5-7.5'
                        }
                      />
                    </svg>
                  </button>
                )}
              </div>

              {showDocuments && documents.length > 0 && (
                <table className="doc-table">
                  <thead>
                    <tr>
                      <th>Sno</th>
                      <th>Notes</th>
                      <th>Document</th>
                    </tr>
                  </thead>
                  <tbody>
                    {documents.map((doc, index) => (
                      <tr key={index}>
                        <td style={{ fontFamily: 'Inter, sans-serif' }}>
                          {index + 1}
                        </td>
                        <td
                          style={{
                            color: '#9ca3af',
                            fontFamily: 'Inter, sans-serif',
                          }}
                        >
                          {doc.notes}
                        </td>
                        <td>
                          <a
                            className="view-doc-btn"
                            href={Constants.FILE_PATH_BASE_URL + doc.document}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth={1.8}
                              stroke="currentColor"
                              style={{
                                width: 18,
                                height: 18,
                                color: '#6b7280',
                              }}
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.964-7.178z"
                              />
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                              />
                            </svg>
                            View Document
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}

              {(file || notes) && (
                <div className="action-row">
                  <button className="cancel-btn" onClick={handleCancel}>
                    Cancel
                  </button>
                  <button className="save-btn" onClick={handleSubmit}>
                    {uploading ? 'Saving...' : 'Save'}
                  </button>
                </div>
              )}
              </div>
              )}
            </div>
          )}

        <div>
          <button
            type="button"
            className="collapse-header"
            onClick={() => setShowReport((prev) => !prev)}
          >
            <span className="report-header-left">
              <span className="report-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                  stroke="currentColor"
                  style={{ width: 16, height: 16 }}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 01-2.555-.337A5.972 5.972 0 015.41 20.97a5.969 5.969 0 01-.474-.065 4.48 4.48 0 00.978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25z"
                  />
                </svg>
              </span>
              <span>
                <div className="collapse-title">Report a problem</div>
                <div className="report-sub">
                  Let us know if there is an issue with this transaction.
                </div>
              </span>
            </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2.5}
              stroke="currentColor"
              className="collapse-chevron"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d={
                  showReport
                    ? 'M4.5 15.75l7.5-7.5 7.5 7.5'
                    : 'M19.5 8.25l-7.5 7.5-7.5-7.5'
                }
              />
            </svg>
          </button>

          {showReport && (
            <div className="report-body">
              <div className="report-question">
                What is the issue with this transaction?{' '}
                <span className="required-star">*</span>
              </div>
              {REPORT_ISSUES.map((issue) => (
                <label key={issue} className="report-option">
                  <input
                    type="radio"
                    name="report-issue"
                    value={issue}
                    checked={formData.title === issue}
                    onChange={() =>
                      setFormData((prev) => ({
                        ...prev,
                        title: issue,
                        category: 'transaction',
                      }))
                    }
                  />
                  {issue}
                </label>
              ))}

              {formData.title && (
                <>
                  <div className="report-label">
                    Please provide additional information about this
                    transaction. <span className="required-star">*</span>
                  </div>
                  <textarea
                    className="report-textarea"
                    rows="3"
                    maxLength={REPORT_DESCRIPTION_MAX}
                    placeholder="Enter your details here..."
                    value={formData.description}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        description: e.target.value,
                      }))
                    }
                  />
                  <div className="report-counter">
                    {formData.description.length}/{REPORT_DESCRIPTION_MAX}
                  </div>

                  <div className="report-label">
                    Upload supporting document (optional)
                  </div>
                  <label
                    htmlFor="report-file-upload"
                    className={`dropzone${dragActive ? ' active' : ''}`}
                    onDragEnter={handleReportDrag}
                    onDragOver={handleReportDrag}
                    onDragLeave={handleReportDrag}
                    onDrop={handleReportDrop}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={2}
                      stroke="currentColor"
                      style={{ width: 18, height: 18, color: '#374151' }}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5"
                      />
                    </svg>
                    <div>
                      <div className="dropzone-title">
                        Choose a file or drag it here
                      </div>
                      <div className="dropzone-sub">
                        JPEG, JPG, PNG, PDF, DOC, DOCX, XLSX, CSV · Max {MAX_FILE_SIZE_MB} MB
                      </div>
                    </div>
                  </label>
                  <input
                    id="report-file-upload"
                    type="file"
                    multiple
                    accept={ALLOWED_ATTACHMENT_ACCEPT}
                    onChange={handleReportFileChange}
                    style={{ display: 'none' }}
                  />

                  {formData.attachments.length > 0 && (
                    <div className="attachment-list">
                      {formData.attachments.map((f, index) => (
                        <div key={index} className="attachment-item">
                          <span>{f.name}</span>
                          <button
                            type="button"
                            className="attachment-remove"
                            onClick={() => removeReportAttachment(index)}
                            title="Remove"
                          >
                            ×
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </>
              )}
            </div>
          )}
        </div>

        {/* Tickets raised for this transaction */}
        {transactionTickets.length > 0 && (
          <div className="tickets-section">
            <div className="collapse-header" style={{ cursor: 'default' }}>
              <span className="collapse-title">Reported Tickets</span>
            </div>
            {transactionTickets.map((ticket, index) => {
              const ticketStatusStyle =
                ticket.status_display === 'Open'
                  ? { dot: 'bg-[#22c55e]', text: 'text-[#16a34a]' }
                  : ticket.status_display === 'Closed'
                    ? { dot: 'bg-[#ef4444]', text: 'text-[#dc2626]' }
                    : { dot: 'bg-gray-400', text: 'text-gray-600' };
              const ticketDescription = splitTransactionId(
                ticket.description,
              ).description;
              return (
                <div
                  key={ticket.id || index}
                  className="flex items-center justify-between px-5 py-4 border-b border-[#F0F4FA] last:border-b-0 hover:bg-[#FAFBFD] transition-colors"
                >
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-full bg-[#0B214E] text-white flex items-center justify-center font-bold text-base shrink-0">
                      {ticket.title?.charAt(0).toUpperCase() || 'T'}
                    </div>

                    <div className="flex flex-col gap-0.5">
                      <div className="flex items-center gap-2 flex-wrap">
                        <span className="text-sm font-semibold text-[#1A202C]">
                          {ticket?.title}
                        </span>
                        {ticket?.createdDate && (
                          <span className="text-xs text-[#A0AEC0]">
                            {ticket.createdDate}
                          </span>
                        )}
                        <span
                          className={`flex items-center gap-1 text-xs font-medium ${ticketStatusStyle.text}`}
                        >
                          <span
                            className={`w-2 h-2 rounded-full ${ticketStatusStyle.dot}`}
                          />
                          {ticket.status_display}
                        </span>
                        {ticket.status_display === 'Closed' && (
                          <img
                            src="/icons/pin-icon.svg"
                            alt="Pin"
                            className="w-4 h-4"
                          />
                        )}
                      </div>

                      <div className="text-sm text-[#4A5568]">
                        <div className="flex flex-row">
                          <span
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(
                                ticketDescription.length > 300
                                  ? ticketDescription.substring(0, 300) + '...'
                                  : ticketDescription,
                                {
                                  ALLOWED_TAGS: [
                                    'b',
                                    'i',
                                    'u',
                                    'a',
                                    'br',
                                    'strong',
                                    'em',
                                    'p',
                                    'ul',
                                    'ol',
                                    'li',
                                  ],
                                  ALLOWED_ATTR: ['href', 'target', 'rel'],
                                },
                              ),
                            }}
                          />
                        </div>
                      </div>

                      {ticket.subtitle && (
                        <p className="text-xs text-[#718096]">
                          {ticket.subtitle}
                        </p>
                      )}
                    </div>
                  </div>
                  <button
                    onClick={() => navigate(`/ticketdetails/${ticket.id}`)}
                    className="flex items-center justify-center w-9 h-9 border border-[#E2E8F0] rounded-lg bg-white hover:bg-[#F5F7FA] text-[#4A5568] shrink-0 ml-4"
                    title="View"
                  >
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"
                      />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                  </button>
                </div>
              );
            })}
          </div>
        )}
        </div>

        {showReport && formData.title && (
          <button
            className={`submit-btn${ticketLoading ? ' loading' : ''}`}
            disabled={ticketLoading || !formData.description.trim()}
            onClick={handleReviewSubmit}
          >
            {ticketLoading ? (
              <>
                <div className="spinner" /> Processing...
              </>
            ) : (
              <>
                Continue
                <ArrowRight className="w-5 h-5 -ml-3" />
              </>
            )}
          </button>
        )}

        {/* Security Banner */}
        <div className="security-banner">
          <span style={{ fontSize: 18 }}>🔒</span>
          <div>
            <div className="security-banner-title">100% Secure & Safe</div>
            <div className="security-banner-sub">
              Your money is protected with bank-level encryption. We never store
              your banking credentials.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TransactionListDetails;